<template>
  <b-card header-tag="header">
    <b-card-header>
      <b-card-title>{{ content.name }}</b-card-title>
      <feather-icon
        icon="CornerLeftUpIcon"
        size="18"
        class="cursor-pointer"
        @click="back()"
      />
    </b-card-header>
    <b-card-body style="min-height: 30vh">
      <b-card-sub-title class="mb-2"
        ><feather-icon :icon="type.icon" class="mr-50" />
        {{ type.title }}</b-card-sub-title
      >
      <b-card-text>
        <object
          style="width: 100%; height: 80vh"
          :data="content.file"
          type="application/pdf"
          v-if="content.type == 'pdf'"
        >
          <embed
            style="width: 100%; height: 80vh"
            :src="content.file"
            type="application/pdf"
          />
        </object>
        <iframe
          :src="`https://docs.google.com/gview?url=${content.file}&embedded=true`"
          v-else-if="content.type == 'powerpoint_lectures'"
          style="width: 100%; height: 80vh"
          frameborder="0"
        ></iframe>
        <audio
          controls
          id="player"
          style="width: 100%"
          height="315"
          class="player"
          v-else-if="content.type == 'uploaded_voice_lectures'"
        >
          <source style="width: 100%" :src="content.file" type="audio/mpeg" />
        </audio>
        <video
          id="video"
          playsinline
          controls
          width="100%"
          height="315"
          v-else-if="content.type == 'video_lectures'"
        >
          <source :src="content.file" type="video/mp4" />
        </video>
        <iframe
          frameborder="0"
          style="width: 100%; height: 70vh"
          :src="
            content.file.replace('.' + content.file.split('.').pop(), '') +
            '/course/index.html'
          "
          v-else-if="content.type == 'scrom_lectures'"
        ></iframe>
        <iframe
          frameborder="0"
          style="width: 100%; height: 700px"
          :src="`${serverUrl}/h5p-content-embed/${content.h5p}`"
          v-else-if="
            content.type == 'voice_lectures' ||
            content.type == 'assessments' ||
            content.type == 'interactive_video_lectures'
          "
        ></iframe>
        <exam :exam-id="content.exam_id" v-else-if="content.type == 'exam'" />
        <details-vue
          :id="content.online_class_id"
          v-else-if="content.type == 'direct_lectures'"
        ></details-vue>
      </b-card-text>
      <hr />
      <b-card-title>وصف المحاضرة </b-card-title>
      <b-card-text v-html="content.description"> </b-card-text>
    </b-card-body>
    <template #footer v-if="content.type != 'exam'">
      <comment :contentId="content.id" :programId="eduProgram.id" />
    </template>
  </b-card>
</template>

<script>
import DetailsVue from "../../Online/Details.vue";
import Comment from "./Comment.vue";
export default {
  components: {
    Comment,
    DetailsVue,
  },
  props: ["content", "eduProgram", "type", "isShowContent"],

  methods: {
    back() {
      // console.log(this.$props.isShowContent);
      //  this.$emit(1, isShowContent);
      this.$emit("click", 1);
      // console.log(this.$props.isShowContent);
      localStorage.removeItem("content");
    },
  },
};
</script>

<style>
</style>